define('modules/lp_info/views/copy_to_popup',['require','exports','module','common/views/modal_layout','base/itemview','base/collectionview','../../page_listing/collections/pages','common/views/alert_view','i18n','ldsh!../templates/page_line_empty','ldsh!../templates/page_line','ldsh!../templates/page_selector','ldsh!../templates/copy_to_popup'],function (require, exports, module) {
  'use strict';

  var ModalLayout = require('common/views/modal_layout'),
    ItemView = require('base/itemview'),
    CollectionView = require('base/collectionview'),
    PagesCollection = require('../../page_listing/collections/pages'),
    AlertView = require('common/views/alert_view'),
    i18n = require('i18n');

  var PageEmptyView = ItemView.extend({
    template: require('ldsh!../templates/page_line_empty'),
    tagName: 'li',
    className: 'ed-loading',
  });

  var PageView = ItemView.extend({
    template: require('ldsh!../templates/page_line'),
    tagName: 'li',
    className: 'ed-selectableItem',
    events: {
      'click span': 'onSelect',
    },

    helpers: function () {
      return { id: this.model.get('id') };
    },

    onSelect: function (e) {
      var ul = this.$el.parents('ul'),
        span = this.$el.find('.js-pages-list-item');
      ul.find('.js-pages-list-item').removeClass('is-selected');
      span.toggleClass('is-selected');
    },
  });

  var PagesView = CollectionView.extend({
    template: require('ldsh!../templates/page_selector'),
    itemView: PageView,
    emptyView: PageEmptyView,
    className: 'ed-selectList',
    itemContainer: 'ul',
    onRender: function () {
      this.$('.ed-loading').toggleClass('hidden', !!this.collection.length);
      this.$el.i18n();
    },
  });

  module.exports = ModalLayout.extend({
    template: require('ldsh!../templates/copy_to_popup'),
    triggers: {
      'click .js-ok': 'ok',
      'click .js-cancel': 'cancel',
    },
    regions: {
      pages: '.js-pages',
    },
    initialize: function () {
      var pagesCollection = new PagesCollection({ paginationIsNeeded: false });
      pagesCollection.once(
        'sync',
        _.bind(pagesCollection.remove, pagesCollection, { id: this.model.get('pages_id') })
      );
      this.regions.pages.show(new PagesView({ collection: pagesCollection }));
      pagesCollection.fetch();
    },
    onRender: function () {
      this.$el.i18n();
    },
    validate: function () {
      //var id = this.$("select").val();
      this.hideErrors();
      var id = this.$('.is-selected').attr('data-value');
      return id ? id : this.showErrors();
    },
    hideErrors: function () {
      this.$('.js-error').addClass('hidden');
    },
    showErrors: function () {
      this.$('.js-error').removeClass('hidden');
    },
    showAlert: function (message, isSuccess) {
      var alert = AlertView.showAlert({
        message: message,
        alertType: isSuccess ? 'success' : 'danger',
      });
    },
  });

  _.extend(module.exports, {
    show: function (variant) {
      var popup = new module.exports({ model: variant }),
        defer = $.Deferred();
      popup.on('ok', function () {
        var id = this.validate();
        if (!id) return;
        this.model.collection
          .copyVariantTo(this.model, id)
          .success(function () {
            popup.showAlert(i18n.t('landingPage.copyVariantSuccess'), true);
            // give some time to AlertView to appear and disappear
            // before wiping out the modal popup
            setTimeout(function () {
              popup.remove();
              defer.resolve(id);
            }, 3500);
          })
          .fail(function () {
            popup.showAlert(i18n.t('landingPage.copyVariantError'));
          });
      });
      popup.on('cancel', _.bind(defer.reject, defer));
      defer.always(_.bind(popup.hide, popup));
      return defer.promise();
    },
  });
});

